const module = { name: 'theater/shared/theaterConcessionAmenity', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile }, theater: serverSideTheater } } = Fandango_context;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_dropdown as dropdown } from 'base-libraries';



import { swig as swig } from 'require-core';



const Selectors = {
    MODAL: '#theater-concessions-options',
    CONTAINER: '#theater-concessions-options',
    SECTION: '#snack-preorder-amenities-overlay',
    OPEN_BTN: '.js-theater-concessions-overlay-open-btn',
    MOBILE: '#near-theaters-concession',
}


const Styles = {
    CONTAINER: 'theater-concessions-options__container',
    CONTAINER_DESKTOP: 'theater-concessions-options__container--desktop',
    CLOSE_BTN: 'theater-concessions-options__close-btn',
}


const DROPDOWN_NAME = 'theaterConcessionsOptionsDesktop'


const BOUND_ATTR = 'data-concession-bound'


const theatersById = new Map()
function launchTrack(platform) {
    track({
        event: EventTypes.CONCESSION_AMENITY_CLICK,
        pageType: 'modal',
        platform,
        server: 'fandango responsive',
        modalName: 'theaters | concession options'
    });
}
function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    dropdown.close(DROPDOWN_NAME);
    const markup = swig.render('_theaterConcessionOverlay', {
        theater: serverSideTheater?.concessionAmenity ? serverSideTheater : theatersById.get(e.currentTarget.dataset.id),
    });
    dropdown.open(markup, {
        closeBtnParent: Selectors.CONTAINER,
        closeBtnStyle: Styles.CLOSE_BTN,
        dropdownStyle: Styles.CONTAINER_DESKTOP,
        name: DROPDOWN_NAME,
        openParent: e.currentTarget.id,
        relativeParent: (isMobile && document.querySelector(`${Selectors.MOBILE}-${e.currentTarget.dataset.id}`))
            || document.querySelector(Selectors.SECTION)
            || `#theater-header-${e.currentTarget.dataset.id}`,
    });
    launchTrack('fandango web');
}
function init(clientSideTheaters) {
    if (clientSideTheaters?.length) {
        clientSideTheaters.forEach(theater => theatersById.set(theater.formattedID, theater));
    }
    const btns = document.querySelectorAll(`${Selectors.OPEN_BTN}:not([${BOUND_ATTR}])`);
    if (!btns.length) {
        return;
    }
    btns.forEach((btn) => {
        btn.setAttribute(BOUND_ATTR, '');
        btn.addEventListener('click', onClick);
    });
}
module.exports = {
    init,
};
export default module.exports;